import React from 'react';
import TransportAll from '../TransportAll/TransportAll';

import './Home.css';


const Home = () => {
    // const homeStyle = {
    //     backgroundImage: 'url(' + bgImage + ')',
    //     backgroundRepeat: 'no-repeat',
    //     // backgroundSize: 'contain',
    //     backgroundSize: 'cover',

    // }

    return (
        <div >
            <TransportAll></TransportAll>
        </div>
    );
};

export default Home;